import { render, staticRenderFns } from "./ImsProfitLossAddOrEditCommissionModal.vue?vue&type=template&id=66e59203&"
import script from "./ImsProfitLossAddOrEditCommissionModal.vue?vue&type=script&lang=js&"
export * from "./ImsProfitLossAddOrEditCommissionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports